// REACT & Libraries
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Common/FilterComponent";

// Table
import { JobTitleTableColumn } from "../../../../Data/DataTables/JobTitle";

// Types
import { ViewJobTitle } from "../../../../Types/MasterData/JobTitles";

// Services
import {
  VIEW_JOBTITLES_QUERY_KEY,
  jobtitleService,
} from "../../../../Services/jobtitlesService";

const JobTitleTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: usersResponse, isLoading } = useQuery({
    queryKey: VIEW_JOBTITLES_QUERY_KEY,
    queryFn: jobtitleService.viewAllJobTitle,
  });

  const filteredItems: ViewJobTitle[] = usersResponse?.data.filter(
    (item: ViewJobTitle) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={JobTitleTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default JobTitleTable;
